import { createApp } from 'vue'
import __t from "../../../../../helpers/translate";
import vue_helpers from "../../../../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import fmtDate from "../../../../../helpers/fmtDay";

import contragent_action from "./contragent_action.vue";

window.P_ACT = createApp({
    name : "P_ACT",
    id : "P_ACT",
    components : {
        contragent_action : contragent_action,
    }
})
    .mixin(fmtDate)
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store);

P_ACT.mount('#contragent_action');